import axios from "~/config/axios";

export async function checkCourseTrialEmail(courseId: string, email: string) {
  const response = await axios.post(`courses/${courseId}/check-trial-email`, {
    email
  });
  return response.data.success;
}
